<template>
  <div class="col-md-4 col-sm-6 col-12 p-4">
    <p>{{ title }}</p>
    <div
      class="boxstylingmobile"
      v-for="(Resource, key) in Resources"
      :key="key"
      @click="handleClick(Resource.slug)"
    >
      <div class="row">
        <div class="col-md-1 col-sm-1 col-1">
          <ICON_Cube :size="icon_size" :color="footer_color" />
        </div>
        <div class="col-md-11 col-sm-11 col-11">
          <h3 class="blogHeader">{{ Resource.title }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ICON_Cube from "@/assets/icons/Cube.vue";
import { goTo } from "@/utility/util";
import axios from "axios";
export default {
  components: {
    ICON_Cube,
  },
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      lang: "en",
      Resources: [],
      footer_color: "black",
      icon_size: 24,
    };
  },
  beforeMount() {
    this.ActionUpdateStore();
  },
  methods: {
    handleClick(slug) {
      goTo(slug);
    },
    ActionUpdateStore() {
      const url =
        "https://au.api.vezham.com/widgets/stringcms/v1/pages/menu_|_resources/collections/group_1/entities/views";
      const config = {
        headers: {
          "Content-Type": "application/json",
          "X-WORKSPACE-WALLET-ADDRESS":
            "0wxkALTb6mKr4ydf502UyB8jldFszVYXS1EawFD4S9kMZpG7WLL2bpSwPuVRe49/FMa2voEmo+MlyMF8LzdEw==",
        },
      };
      let data = {
        language_code: this.lang,
        sort_by: [
          {
            field: "order",
            order: "asc",
          },
        ],
      };
      axios
        .post(url, data, config)
        .then(({ data }) => {
          if (data.meta.status != "success") {
            this.Resources = [];
            return;
          } else if (data.data.length == 0) {
            this.Resources = [];
            return;
          }
          this.Resources = data.data;
        })
        .catch(() => {});
    },
  },
};
</script>
